<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2021-09-28 15:05:40
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-04-23 14:42:41
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/linkmec/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="container">
    <div @click="showRule" class="ruleBtn">活动规则</div>
    <div class="banner">
      <img
        src="https://source.qunarzz.com/site/images/wns/20221219-shijianchen-gf-1.jpg"
        alt=""
      />
      <img
        src="https://source.qunarzz.com/site/images/wns/20221219-shijianchen-gf-3.png"
        class="banner-tit"
        alt=""
      />
    </div>
    <appoint />
    <div class="card2">
      <img
        src="https://source.qunarzz.com/site/images/wns/20221220-shijianchen-card.png"
        class="cardImg"
        alt=""
      />
      <div class="title">
        <img
          class="cardImg"
          src="https://source.qunarzz.com/site/images/wns/20221219-shijianchen-gf-2.png"
          alt=""
        />
      </div>
      <lineComp :lineList="lineList"></lineComp>
      <div class="title">
        <img
          class="cardImg"
          src="https://source.qunarzz.com/site/images/wns/20230423-shijianchen-gy-tit1.png"
          alt=""
        />
      </div>
      <lineComp2 :lineList="lineList"></lineComp2>
      <img
        src="https://source.qunarzz.com/site/images/wns/20221219-shijianchen-gf-4.png"
        class="cardImg cardImg2"
        alt=""
      />
      <div class="swipe-wrapper">
        <mt-swipe :auto="0" ref="swipeWrapper">
          <mt-swipe-item v-for="(item, index) in imgList" :key="index">
            <div class="img-box">
              <div class="img">
                <img :src="item" alt="" />
              </div>
            </div>
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <a href="https://www.gac-toyota.com.cn/vehicles/sienna" class="lookMore">点击官网 查看更多</a>
      <img
        src="https://source.qunarzz.com/site/images/wns/20221220-shijianchen-bottom.jpg"
        alt=""
      />
    </div>
  </div>
</template>
<script>
// import Home from './home.vue'
import loginDialog from '@/components/login/index';
import lineComp from './line.vue';
import lineComp2 from './line2.vue';
import keepDialog from './dialog/gift2/index';
import giftDialog from './dialog/gift/index';
import videoComp from './video.vue';
import gotomini from './gotomini.vue';
import ruleDialog from './dialog/ruleDialog/index';
import appoint from './appoint.vue';
export default {
  components: {
    lineComp,
    lineComp2,
    videoComp,
    gotomini,
    appoint,
  },
  data() {
    return {
      hasLottery: false,
      imgList: [
        'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-swipe-6.png',
        'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-swipe-5.png',
        'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-swipe-2.png',
        'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-swipe-3.png',
        'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-swipe-4.png',
        'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-swipe-1.png',
        'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-swipe-7.png',
      ],
      lineList: [
        [
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun1.png',
            tagList: ['雪山温泉', '草原'],
            price: 4300,
            tag: '服务贴心/早餐很赞',
            desc: '昆明出发-跟团游 高端纯玩VIP独立小包 | 保山+芒市+腾冲双动6日 | 高端酒店 漫步银杏村+和顺侨乡+勐焕大金塔+勐巴娜西珍奇园+梦幻腾冲',
            descList: [],
            linkId:
              'https://touch.dujia.qunar.com/p/item/1189671947?date=2022-12-21&et=home_vacation_t&it=dujia_hy_destination&routeId=54753920&listDep=%E5%8C%97%E4%BA%AC',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun2.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 4160,
            desc: '「官方自营」天目湖旅游度假区御湖半岛温泉酒店|庭院温泉大床房1晚+双人营养早餐+独立泡池+双人特色正餐',
            tag: '环境舒适/客房干净',
            linkId:
              'http://touch.dujia.qunar.com/detail.qunar?id=3037586127&et=dpp_ep_22wq',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun3.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 7510,
            desc: '杭州湍口众安氡温泉度假酒店1晚+双人早餐+无限次温泉+晚餐可选',
            tag: '房间干净/环境舒适',
            linkId:
              'http://touch.dujia.qunar.com/detail.qunar?id=1992357023&et=dpp_ep_22wq',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun4.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 7510,
            desc: '自由行【古北水镇十三妹温泉酒店】赠私汤温泉+电瓶车| 古北水镇2日游+含早餐+含门票',
            tag: '房间干净/环境舒适',
            linkId:
              'https://touch.dujia.qunar.com/p/item/287585773?t3id=624455933&date=2022-12-20&et=dpp_ep_22wq&it=dujia_hy_destination&routeId=120129440&it=dujia_hy_destination&et=dpp_ep_22wq',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun5.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 7510,
            desc: '魔界雾凇漂流❄长白山温泉·天池+5A镜泊湖·冬捕+雪乡6天🏂万科滑雪3H-童话冰雪大世界+东北虎园林+孔雀园丨五钻酒店',
            tag: '房间干净/环境舒适',
            linkId:
              'https://touch.dujia.qunar.com/p/item/3518460823?date=2022-12-22&et=dpp_ep_22wq&it=dujia_hy_destination&routeId=445897301&it=dujia_hy_destination&et=dpp_ep_22wq&tuId=PID3518460823G379178948',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun6.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 7510,
            desc: '奢雅谧境·最美悬崖酒店 | 重庆柏联酒店~俯瞰嘉陵江·溶洞北温泉！尊享江景客房+园林温泉+水果小食等11特惠套餐',
            tag: '房间干净/环境舒适',
            linkId:
              'https://touch.dujia.qunar.com/p/item/465253613?tid=995991897&et=dpp_ep_22wq&it=dujia_hy_destination&routeId=131037320&it=dujia_hy_destination&et=dpp_ep_22wq',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun7.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 7510,
            desc: '湖州3日2晚私家团',
            tag: '房间干净/环境舒适',
            linkId:
              'https://touch.dujia.qunar.com/pg/cq-detail/index?pid=2602377660&ctrDepId=2&ctrId=32384997&routeId=128861220&listDep=%E4%B8%8A%E6%B5%B7&it=private_travel&et=dpp_ep_22wq',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221220-shijianchen-lun8.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 7510,
            desc: '五星温泉酒店💥专车专享💥太舒适「星光夜市│品茶+制茶│泼水节」+特色餐',
            tag: '房间干净/环境舒适',
            linkId:
              'https://touch.dujia.qunar.com/p/item/161424325?date=2022-12-21&et=dpp_ep_22wq&it=dujia_hy_destination&routeId=131037800&it=private_travel&et=dpp_ep_22wq',
            discountId: '3770793980',
          },
        ],
      ],
      videoList: [
        {
          src: 'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-video11.mp4',
          poster:
            'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-poster1.png',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-video21.mp4',
          poster:
            'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-poster2.png',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-video31.mp4',
          poster:
            'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-poster3.png',
        },
      ],
      voteCount: 0,
      setting: {
        lz: 0,
        xcx: 0,
      },
    };
  },
  mounted() {
    // loginDialog({});
    this.getChannelNum();
  },
  methods: {
    showRule: ruleDialog,
    gohome() {
      location.href = 'https://iaq.panasonic.cn/';
    },
    submit(params, done) {
      this.$http({
        url: '/keepInfo/keepInfoPanasonic',
        type: 'post',
        data: {
          name: params.userName,
          phone: params.userPhone,
        },
        success: (res) => {
          if (res.code == 200) {
            this.$dialog.alert({
              message: '提交成功',
            });
            // done && done();
            this.addTimeBySource('lz');
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        },
      });
    },
    getMyPrize() {
      this.$http({
        url: '/commonly/getMyPrzie',
        type: 'get',
        success: (res) => {
          let result = [];
          res.data.forEach((item) => {
            result.push(item);
          });
          this.hasLottery = result.length > 0;
        },
      });
    },
    lotteryFn() {
      this.$http({
        url: '/commonly/v2/lottery',
        type: 'post',
        success: (res) => {
          giftDialog({
            type: res.data.code,
            callback: (params, done) => {
              this.getChannelNum();
            },
          });
          this.getChannelNum();
        },
      });
    },
    lookFn() {
      location.href =
        'https://touch.dujia.qunar.com/pg/pv/event/sx8z?et=ip_yh_sx';
    },
    addTimeBySource(source) {
      this.$http({
        url: '/commonly/addTimeBySource?source=' + source,
        type: 'get',
        login: loginDialog,
        error: () => {},
        success: (res) => {
          // this.voteCount = res.data.voteCount;
          this.getChannelNum();
        },
      });
    },
    keepInfo() {
      keepDialog({
        callback: (params, done) => {
          this.submit(params, done);
        },
      });
    },
    getChannelNum() {
      this.$http({
        url: '/commonly/getChannelNum',
        type: 'get',
        error: () => {},
        success: (res) => {
          this.setting = res.data;
          this.voteCount = res.data.zs;
          this.getMyPrize();
        },
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
#container {
  background-color: #f2e8d4;
  min-height: 100vh;
}
.banner {
  position: relative;
  &-tit {
    position: absolute;
    bottom: 12px;
    width: 300px;
    left: 50%;
    transform: translateX(-50%);
    width: 271px;
  }
}
.card2 {
  margin-top: 20px;
}
.cardImg {
  width: calc(100% - 46px);
  margin: 0 auto;
}
.cardImg2 {
  margin-bottom: 20px;
  margin-top: 28px;
}
.ruleBtn {
  position: absolute;
  right: 10px;
  top: 15px;
  width: 66px;
  height: 23px;
  background: rgba(61, 61, 61, 0.54);
  border-radius: 12px;
  font-size: 12px;
  z-index: 10;
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  margin-top: 15px;
}
.tabs {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  .tab {
    position: relative;
    height: 127px;
    width: 168px;
  }
  img {
    width: 168px;
    height: 127px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .tab-btn {
    position: absolute;
    left: 12px;
    bottom: 15px;
    width: 70px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ecca98;
    background: #bc8d49;
    border-radius: 13px;
    &2 {
      background-color: #4bb9c2;
      color: #fff;
    }
  }
}
.des {
  opacity: 0.6;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #0056a7;
  letter-spacing: 0;
  line-height: 17px;
  font-weight: 400;
  margin-top: 8px;
  margin-bottom: 8px;
}
.qrcode {
  margin-left: 16px;
  margin-right: 16px;
  width: calc(100% - 32px);
}
.submit {
  background-image: linear-gradient(154deg, #2ab9f9 0%, #059aed 100%);
  border-radius: 12px;
  margin-left: auto;
  margin-right: auto;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  // opacity: 0.5;
  font-size: 18px;
}
.card {
  background-image: linear-gradient(179deg, #e8f4ff 0%, #ffffff 24%);
  border: 1px solid rgba(255, 255, 255, 1);
  width: calc(100% - 32px);
  margin-left: auto;
  padding-top: 20px;
  margin-right: auto;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 15px;
  border-radius: 20px;
}
.cardBoth {
  display: flex;
  justify-content: space-between;
  margin-top: 7px;
  img {
    width: 168px;
    height: 67px;
  }
}
.gotome {
  width: 355px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid rgba(0, 86, 167, 1);
  border-radius: 18px;
  margin: 0 auto;
  font-size: 13px;
  color: #0056a7;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 26px;
  margin-bottom: 70px;
}
.lookMore {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #6B3929;
  text-decoration: underline;
  line-height: 28px;
  text-align: center;
}
.swipe-wrapper {
  height: 240px;
  width: 355px;
  margin: 0 auto;
  /deep/ .mint-swipe-indicator {
    width: 5px;
    height: 5px;
    background: #d0c09f;
    border-radius: 50%;
    opacity: 1;
  }
  /deep/ .mint-swipe-indicator.is-active {
    width: 31px;
    height: 5px;
    background: #d0c09f;
    border-radius: 3px;
    opacity: 1;
  }
}
</style>